module.exports = __webpack_public_path__ + "media/images/menu/archive-72b02ca3a88cf2c10aae008286530781.jpg";